// Display mirror of the guest tiers. The source of truth is functions/src/utils/eventTiers.ts; keep the two lists in step.

export const GUEST_TIERS = [25, 50, 100, 200, 400] as const;

export function tierLabel(cap: number): string {
  return `${cap}-guest tier`;
}
